const topics = [
  { label: '韩漫推荐', hot: true, count: '12.8万' },
  { label: '日漫新番', hot: true, count: '9.6万' },
  { label: '国漫古风', hot: true, count: '8.3万' },
  { label: '热血少年', hot: false, count: '7.1万' },
  { label: '甜蜜恋爱', hot: false, count: '6.5万' },
  { label: '悬疑推理', hot: true, count: '5.9万' },
  { label: '奇幻冒险', hot: false, count: '5.2万' },
  { label: '搞笑日常', hot: false, count: '4.8万' },
  { label: '校园青春', hot: false, count: '4.3万' },
  { label: '治愈系', hot: false, count: '3.7万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">大家都在讨论的热门漫画类型与标签</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#ranking"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-200 bg-background-100 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <span className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors">{t.label}</span>
              {t.hot && (
                <span className="flex items-center gap-0.5 text-xs text-primary-500">
                  <i className="ri-fire-line text-xs" />
                </span>
              )}
              <span className="text-xs text-foreground-400 bg-background-200/50 px-1.5 py-0.5 rounded">{t.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}